import axios from 'axios'
import { StudentAwardPreviewResultSchema } from './schema'
import { parseRequestError } from '@/common/utilities.ts'

export type GetStudentAwardPreviewParams = {
  programId: number
  studentIds: number[]
  /** Purses to price the awards against. Every id must belong to `programId`. */
  programPurseIds: number[]
}

/**
 * Breaks the awarded amounts ServiceNow supplied down per purse for the given students, so the
 * award form can price every candidate purse in one request instead of one per purse. Read-only.
 */
export const getStudentAwardPreview = async ({
  programId,
  studentIds,
  programPurseIds,
}: GetStudentAwardPreviewParams) => {
  try {
    const response = await axios.get(
      `/programs/${programId}/student_award_preview`,
      {
        params: {
          student_ids: studentIds,
          program_purse_ids: programPurseIds,
        },
      }
    )
    return StudentAwardPreviewResultSchema.parse(response.data)
  } catch (e) {
    throw parseRequestError(e)
  }
}
